import aiEmployees from './ai/ai-employees';
import bank from './banking/bank';
import bankRecon from './banking/bank-recon';
import bankRules from './banking/bank-rules';
import app from './core/app';
import organisation from './core/organisation';
import entity from './crm/entity';
import teamMember from './hr/team-member';
import payroll from './hr/payroll';
import selectedTeamMemberDeduction from './hr/selected-team-member-deduction';
import selectedInvestment from './investment/selected-investment';
import selectedIssuedLoan from './loans/selected-issued-loan';
import selectedReceivedLoan from './loans/selected-received-loan';
import selectedExpense from './payables/selected-expense';
import selectedPurchaseOrder from './payables/selected-purchase-order';
import selectedPurchasesCreditMemo from './payables/selected-purchases-credit-memo';
import selectedInvoice from './receivables/selected-invoice';
import selectedSale from './receivables/selected-sale';
import selectedSalesCreditMemo from './receivables/selected-sales-credit-memo';
import country from './system/country';
import currency from './system/currency';
import timezone from './system/timezone';

export default {
    aiEmployees,
    bank,
    bankRecon,
    bankRules,
    app,
    organisation,
    entity,
    teamMember,
    payroll,
    selectedTeamMemberDeduction,
    selectedInvestment,
    selectedIssuedLoan,
    selectedReceivedLoan,
    selectedExpense,
    selectedPurchaseOrder,
    selectedPurchasesCreditMemo,
    selectedInvoice,
    selectedSale,
    selectedSalesCreditMemo,
    country,
    currency,
    timezone,
};
